import { useApiPrivateRequest } from "../../../shared/hooks/useApi";

export const useSharePlaybook = () => {
  const { call, isLoading, isFailed } = useApiPrivateRequest<boolean>(
    (_) => true,
  );

  const sharePlaybook = async (playbookId: string, email: string) => {
    await call(
      `/playbooks/${playbookId}/share?email=${encodeURIComponent(email)}`,
      "POST",
    );
  };

  return { sharePlaybook, isLoading, isFailed };
};
